'use client';
import { isBrowser } from '@s7/platform';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var isSameHost = function(url) {
    if (!isBrowser()) {
        return;
    }
    return url.startsWith("/") || url.startsWith("#") || url.includes(window.location.host);
};
var openResource = function(param) {
    var url = param.url;
    if (url && isBrowser()) {
        window.open(url, isSameHost(url) ? "_self" : "_blank");
    }
};
var unpackLink = function(link) {
    if (!link) {
        return undefined;
    }
    var url = link.url, others = _object_without_properties_loose(link, [
        "url"
    ]);
    if (!url) {
        return _extends({
            as: "button"
        }, others);
    }
    return _extends({
        as: "a",
        href: url
    }, !isSameHost(url) && {
        target: "_blank"
    }, others);
};

export { isSameHost, openResource, unpackLink };
